<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>平台列表</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
          <el-form-item label="平台ID" prop="userId">
            <el-input v-model="searchForm.id" placeholder="请输入平台ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="平台名称" prop="username">
            <el-input v-model="searchForm.name" placeholder="请输入平台名称"></el-input>
          </el-form-item>
          <el-form-item label="用户ID" prop="userId">
            <el-input v-model="searchForm.userId" placeholder="请输入用户ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="用户昵称" prop="username">
            <el-input v-model="searchForm.username" placeholder="请输入用户昵称"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="searchForm.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="用户等级" prop="vipLevel">
            <el-select v-model="searchForm.vipLevel" placeholder="请选择用户等级" filterable clearable>
              <el-option v-for="item in dictionaries.platform_vip_level" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="平台类目" prop="categoryIds">
            <el-cascader :options="categoryList" v-model="searchForm.categoryIds" :show-all-levels="false"
              :props="{ multiple: true, checkStrictly: true, emitPath: false }" @change="onChangeCategory"
              clearable></el-cascader>
          </el-form-item>
          <el-form-item label="平台类型" prop="type"><el-select v-model="searchForm.type" placeholder="请选择平台类型" clearable>
              <el-option label="矩阵小程序" value="0"></el-option>
              <el-option label="投流小程序" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上线时间" prop="brandId">
            <el-date-picker v-model="openTime" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :clearable="false"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" placeholder="请选择状态" filterable clearable>
              <el-option v-for="item in statuss" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('search')">查询</el-button>
            <el-button type="primary" plain @click="getList('reset')">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="height:10px"></div>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" @click="refeshSetting"
            v-if="this.parArray.indexOf('platforms_resetConfigAll') != -1">刷新配置</el-button>
          <el-button type="primary" @click="add('add')">新增平台</el-button>
          <el-button type="primary" @click="setting()">平台设置</el-button>
          <el-button type="primary" @click="deriveDeliver">批量导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
          :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog title="提示信息" :visible.sync="isN" width="643px" :append-to-body="true" :close-on-click-modal="false"
      custom-class="infoI">
      <div slot="title">
        <div><i class="el-icon-warning" style="font-size: 22px;color:#edb840"></i><span
            style="fontSize: 22px;">提示信息</span></div>
      </div>
      <div v-if="this.pIsInsideBuy == 0">该平台确认是否开启【内购】价格？开启后，内部人员下单按内购价格下单购买！</div>
      <div v-if="this.pIsInsideBuy == 1">该平台确认是否关闭【内购】价格？关闭后，所有用户按零售价格下单购买！</div>
      <div style="display: flex; justify-content: end; margin-top: 24px">
        <div class="info-q" @click="isN = false">取消</div>
        <div class="info-s" @click="submitN">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data() {
    return {
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '平台列表', path: '', type: '1' }
        ]
      },
      searchForm: {
        id: '',
        name: '',
        userId: '',
        username: '',
        phone: '',
        vipLevel: '',
        categoryIds: [],
        openTimeStart: '',
        openTimeEnd: '',
        status: '',
        pageNo: 1,
        pageSize: 10,
        type: ''
      },
      openTime: [],
      statuss: [
        {
          id: '0',
          name: '未上线'
        },
        {
          id: '1',
          name: '已上线'
        }
      ],
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '平台ID', prop: 'id', minWidth: '120' },
        {
          label: '平台', prop: 'name', minWidth: '120',
          render: (h, scope) => {
            return (
              <div><el-link size='mini' type='primary' onClick={() => { this.optionHref(scope.row.token) }}>{scope.row.name}</el-link></div>
            )

          }
        },
        {
          label: '平台图片',
          minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <el-image src={scope.row.mainImageArr ? scope.row.mainImageArr[0] : ''} preview-src-list={scope.row.mainImageArr} lazy></el-image>
              </div >
            )
          }
        },
        {
          label: '关联用户',
          prop: 'username',
          minWidth: '220',
          render: (h, scope) => {
            return (
              <div>
                <p>姓名:{scope.row.username}</p>
                <p>ID:{scope.row.userId}</p>
                <p>电话:{scope.row.userPhone}</p>
              </div>
            )
          }
        },
        { label: '等级', prop: 'vipLevelName', minWidth: '120' },
        {
          label: '平台类型', prop: 'typeLabel', minWidth: '120',

        },
        {
          label: '平台类目', prop: 'str', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p style="max-height: 120px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;">{scope.row.str ? scope.row.str : '--'}</p>
              </div>
            )
          }

        },
        { label: '允许上架数量', prop: 'maxGoodsNum', minWidth: '120' },
        {
          label: '上线时间', prop: 'openTime', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.openTime ? scope.row.openTime : '--'}</p>
              </div>
            )
          }
        },
        {
          label: '是否内购',
          minWidth: '100',
          render: (h, scope) => {
            let v = ''
            if (scope.row.type == 0 && scope.row.statusLabel == '已上线') {
              v = <el-switch
                onChange={() => { this.isUpN(scope.row, scope.$index) }}
                v-model={scope.row.isInsideBuyL}
                active-color="#409EFF"
                inactive-color="#EBEEFA">
              </el-switch>
            } else {
              v = '--'
            }

            return (
              <div>
                {v}
              </div>
            )
          }
        },
        {
          label: '状态',
          minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <p class={scope.row.statusLabel === '已上线' ? 'success' : 'danger'}>{scope.row.statusLabel}</p>
              </div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '180',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-link size='mini' type='primary' onClick={() => { this.add('edit', scope.row.id) }}>编辑</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('look', scope.row.id) }}>查看</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('set', scope.row.id) }}>设置会员</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('applet', scope.row.id) }} class={this.parArray.indexOf('associationApplet') != -1 ? ' ' : 'hide-content'}>关联小程序</el-link>
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: true,
      limits: [],
      parArray: [],
      isN: false,
      pIndex: '',
      pId: '',
      pIsInsideBuy: ''
      // strL: 'platform:list:applet'
    }
  },
  created() {
    this.getCategoryList()
    this.getDictionaries('platform_vip_level')
    // this.getList()
    this.limits = JSON.parse(sessionStorage.getItem("limit"));
    const params = this.limits.buttonTreeDto.filter(
      (item) => item.menuCode === "platList"
    );
    params[0].buttonList.forEach((item) => {
      this.parArray.push(item.code);
    });
    console.log(this.parArray)
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'platListDetail') {
      next(vm => {
        vm.getList();
      });
    } else {
      next(vm => {
        vm.getList();
      });
    }
  },
  mounted() {

  },
  methods: {
    optionHref(token) {
      let url = process.env.VUE_APP_API_BASE_URL_LINK + '/#/center?token='
      //let token = 'eyJhbGciOiJIUzUxMiIsInppcCI6IkdaSVAifQ.H4sIAAAAAAAAACWNSw7CMAxE7-J1I9WpMUnvwbpy1ES0ooDqZFEh7o4rVqM3H80H1rrACIUl0IXFYfLiKGJygYidv-ZZEvcFEaGDRSqMyNEH6iMNHWhLttZDa97OXNVwvU_vh9Ty2k9P2vyv3DTvxs3kKVs289CCfrBf-P4AZUlF54kAAAA.KAYf1jYnqPBXg9p8g9lCGCMkSCRIzyeJcx-nyy9TfI-pj6cQaMWWMML-u8Y-CrkXPn4FDEW-x9hyP7T4aPX68w'
      window.open(url + token);
    },
    submitN() {
      let isInsideBuy = 0
      if (this.pIsInsideBuy == 0) {
        isInsideBuy = 1
      } else {
        isInsideBuy = 0
      }
      let data = {
        id: this.pId,
        isInsideBuy: isInsideBuy
      }
      this.axios.post('/ps/platforms/turnInnerBuy', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.isN = false
          this.getList()
        }
      })

    },
    isUpN(row, index) {
      console.log(row, index)
      this.isN = true
      this.pIndex = index
      this.pId = row.id
      this.pIsInsideBuy = row.isInsideBuy
      if (this.pIsInsideBuy == 0) {
        this.list[index].isInsideBuyL = false
      } else {
        this.list[index].isInsideBuyL = true
      }

    },
    refeshSetting() {
      this.axios.get('/ps/platforms/resetConfigAll').then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '刷新成功'
          })
        } else {
          this.$message({
            type: 'success',
            message: '刷新失败'
          })
        }
      })
    },
    //导出
    deriveDeliver() {
      this.$api.exportPlatformsList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onChangeCategory() {

    },
    onMultipleSelection(val) {
      this.selectionGoods = val
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    getList(type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.openTime = []
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (this.openTime) {
        this.searchForm.openTimeStart = this.openTime[0]
        this.searchForm.openTimeEnd = this.openTime[1]
      } else {
        this.searchForm.openTimeStart = ''
        this.searchForm.openTimeEnd = ''
      }
      console.log(this.searchForm.categoryIds)
      this.$api.getplatformsList(this.searchForm).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            item.mainImageArr = []
            item.mainImageArr.push(item.logoUrl)
            if (item.type == 1) {
              item.maxGoodsNum = '--'
            }
            let str = ''
            if (item.categoryNames) {
              item.categoryNames.forEach(itm => {
                if (str == '') {
                  str = itm
                } else {
                  str = str + ',' + itm
                }

              })
              Object.assign(item, { str: str })
            } else {
              Object.assign(item, { str: '--' })
            }
            if (item.isInsideBuy == 0) {
              item.isInsideBuyL = false
            } else {
              item.isInsideBuyL = true
            }
          })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false;
        }
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_vip_level'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList() {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        res.data.list.forEach(item => {
          if (item.children) {
            item.children.forEach(itm => {
              if (itm.children) {
                delete itm.children
              }
            })
          }
        })
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    add(type, id) {
      if (type == 'look') {
        this.$router.push({
          name: 'lookPlatform',
          query: {
            type: type,
            id: id
          }
        })
      } else if (type == 'set') {
        this.$router.push({
          name: 'settingVip',
          query: {
            type: type,
            id: id
          }
        })
      } else if (type == 'applet') {
        this.$router.push({
          name: 'applet',
          query: {
            type: type,
            id: id
          }
        })
      } else {
        this.$router.push({
          name: 'platListDetail',
          query: {
            type: type,
            id: id
          }
        })
      }

    },
    setting() {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
.infoI {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);

  .el-dialog__header {
    background-color: #ffffff;
    border-bottom: none !important
  }

  .el-dialog__body {
    // padding: 30px 25px;
    // height: 800px;
    flex: 1;
    overflow: auto;
  }

}

.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
<style scoped lang="scss">
.info-q {
  width: 120px;
  height: 36px;
  line-height: 36px;
  background: #ffffff;
  border: 1px solid #D9D9D9;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 120px;
  height: 36px;
  line-height: 36px;
  background: #4168E7;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.hide-content {
  display: none !important;
}

::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>

